import useStripe from 'hooks/useStripe';
import useStripeSubscriptions from 'hooks/useStripeSubscriptions';

const useData = () => {
    const { fetchCustomerPortalSessionUrl } = useStripe();
    const { isLoading, stripeSubscriptions } = useStripeSubscriptions();

    return {
        fetchCustomerPortalSessionUrl,
        isLoading,
        stripeSubscription: stripeSubscriptions
    };
};

export default useData;
